// extracted by mini-css-extract-plugin
export default {"whySpotifyToWhyWebEngineer":"WhySpotifyToWhyWebEngineer_whySpotifyToWhyWebEngineer__0fWKQ","arrowRightIcon":"WhySpotifyToWhyWebEngineer_arrowRightIcon__13IxP"};